import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SharedModule } from '@shared/shared.module';

import { environment } from '@env/environment';

const projectUrl = `${environment.apiBaseUrl}platform/projects`;

@Injectable({
  providedIn: SharedModule
})
export class ProjectService {

  constructor(private http: HttpClient) { }

  get(id: string): Observable<any> {
    return this.http.get<any>(`${projectUrl}/${id}/projectcard`);
  }

  getResult(projectId: string, type: string, date?: string): Observable<any> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    const body = {
      projectCardWidgetType: type
    };

    let params = new HttpParams();

    if (date) {
      params = params.append('fromDate', date);
    }

    return this.http.post<any>(`${projectUrl}/${projectId}/projectcard`, body, {headers, params});
  }
}
